import { IConfig } from '@framework/i18n';
import * as constants from './constants.mjs';

export const config: IConfig = {
  locales: constants.LOCALES_LIST,
  defaultLocale: constants.DEFAULT_LOCALE,
  localeDetection: constants.LOCALE_DETECTION,
  detection: {
    // order and from where user language should be detected
    order: ['path', 'querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator'],

    // keys or params to lookup language from
    lookupQuerystring: 'lng',
    lookupCookie: 'NEXT_LOCALE',
    lookupLocalStorage: 'i18nextLng',
    lookupSessionStorage: 'i18nextLng',
    lookupFromPathIndex: 0,

    cookieMinutes: 60 * 24 * 30, // 30 days
    // cache user language on
    caches: ['localStorage', 'cookie'],
    excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
  },
  getResourcesFromBackend: (lng, ns) => import(`@/dealroadshow/ui/translations/${ ns }/locales/${ lng }/translation.json`),
};
